import type { KarlAsk } from "../karlAsks";
import type { OrderKarlAsks } from "./types";

export const orderKarlAsks: OrderKarlAsks = ({ asks, state }) => {
  const settled = new Set(state.history.map((record) => record.askId));
  const putOff = new Set(state.deferred);
  const byId = new Map<string, KarlAsk>(asks.map((ask) => [ask.id, ask]));

  const stored = asks.filter((ask) => ask.isStored && !settled.has(ask.id) && !putOff.has(ask.id));
  const pending = asks.filter(
    (ask) => !ask.isStored && !settled.has(ask.id) && !putOff.has(ask.id),
  );

  // An ask the rebuild no longer carries simply drops out of the defer list.
  const deferred = state.deferred
    .map((askId) => byId.get(askId))
    .filter((ask): ask is KarlAsk => Boolean(ask));

  return { pending, deferred, queue: [...pending, ...deferred], stored };
};
